<tg-row class="summary-page-summary-section__header">
    <tg-col md="6" sm="12">
        <p class="p-lead-copy">Summary</p>
    </tg-col>
</tg-row>
<tg-row *ngIf="!isNewHomeCategory">
    <tg-col class="summary-page-summary-section__content" sm="6">
        <span class="summary-page-summary__content-label">
            Total fees to pay
        </span>
    </tg-col>
    <tg-col sm="6" class="summary-page-summary-section__content">
        <span class="summary-page-summary-section__priceDisplay">
            {{ priceDisplay }}
        </span>
    </tg-col>
</tg-row>
<tg-row *ngIf="!isBasePackageSelectionForRelistPage">
    <tg-col class="summary-page-summary-section__fees-message-box">
        <tg-info-box>
            <tg-info-box-heading *ngIf="!usePartnershipAgreement()">
                A fee applies to this listing
            </tg-info-box-heading>
            <tg-info-box-heading *ngIf="usePartnershipAgreement()">
                Your Partnership Agreement package has been applied
            </tg-info-box-heading>
            Check your rate card or contact
            <a href="mailto:{{ defaultContactSupportEmail }}">
                {{ defaultContactSupportEmail }}
            </a>
            for details.
        </tg-info-box>
        <tg-info-box *ngIf="hasIncreasedRV && !isAgent">
            <tg-info-box-heading>
                An additional fee will be invoiced for the RV change
            </tg-info-box-heading>
            Check your rate card or contact
            <a href="mailto:{{ defaultContactSupportEmail }}">
                {{ defaultContactSupportEmail }}
            </a>
            for details.
        </tg-info-box>
    </tg-col>
</tg-row>
